import React from 'react';
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { useLanguage } from '../../../context/LanguageContext';
import './Testimonials.css';

const Testimonials: React.FC = () => {
  const { t } = useLanguage();
  
  const testimonials = [
    {
      id: 1,
      name: t('testimonials.testimonial1.name'),
      country: t('testimonials.country'),
      rating: 5,
      content: t('testimonials.testimonial1.text'),
      platform: 'Google'
    },
    {
      id: 2,
      name: t('testimonials.testimonial2.name'),
      country: t('testimonials.country'),
      rating: 5,
      content: t('testimonials.testimonial2.text'),
      platform: 'Google'
    },
    {
      id: 3,
      name: t('testimonials.testimonial3.name'),
      country: t('testimonials.country'),
      rating: 5,
      content: t('testimonials.testimonial3.text'),
      platform: 'Google'
    },
    {
      id: 4,
      name: t('testimonials.testimonial4.name'),
      country: t('testimonials.country'),
      rating: 5,
      content: t('testimonials.testimonial4.text'),
      platform: 'Google'
    },
    {
      id: 5,
      name: t('testimonials.testimonial5.name'),
      country: t('testimonials.country'),
      rating: 5,
      content: t('testimonials.testimonial5.text'),
      platform: 'Google'
    },
    {
      id: 6,
      name: t('testimonials.testimonial6.name'),
      country: t('testimonials.country'),
      rating: 5,
      content: t('testimonials.testimonial6.text'),
      platform: 'Google'
    }
  ];

  // Duplicate testimonials to ensure we have enough slides for loop mode
  const allTestimonials = testimonials.length < 6 
    ? [...testimonials, ...testimonials] 
    : testimonials;

  return (
    <section id="testimonials" className="testimonials-section py-5 bg-light">
      <Container>
        {/* Google Reviews Badge */}
        <div className="d-flex justify-content-center mb-4">
          <div className="google-reviews-badge">
            <div className="google-logo-container">
              <div className="google-logo">
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
              </div>
              <div className="reviews-text-container">
                <span className="reviews-text">Reviews</span>
                <div className="stars-container">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-5">
          <div className="luxury-title-container">
            <h2 className="luxury-section-title">{t('testimonials.title')}</h2>
            <div className="luxury-underline"></div>
          </div>
          <p className="luxury-subtitle">
            {t('testimonials.subtitle')}
          </p>
        </div>

        <div className="testimonials-slider-container">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={{
              nextEl: '.testimonials-nav .swiper-button-next',
              prevEl: '.testimonials-nav .swiper-button-prev',
            }}
            pagination={{
              clickable: true,
              el: '.testimonials-pagination',
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            loop={allTestimonials.length >= 3}
            breakpoints={{
              768: {
                slidesPerView: Math.min(2, allTestimonials.length),
              },
              1024: {
                slidesPerView: Math.min(3, allTestimonials.length),
              },
            }}
            className="testimonials-slider"
          >
            {allTestimonials.map((testimonial, index) => (
              <SwiperSlide key={`${testimonial.id}-${index}`}>
                <div className="luxury-testimonial-card">
                  <div className="testimonial-header">
                    <div className="stars-container">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="fas fa-star"></i>
                      ))}
                    </div>
                    <div className="testimonial-platform">
                      <span className="platform-badge">{testimonial.platform}</span>
                    </div>
                  </div>
                  
                  <div className="testimonial-content">
                    <p>"{testimonial.content}"</p>
                  </div>
                  
                  <div className="testimonial-author">
                    <div className="author-info">
                      <span className="author-location">{testimonial.country}</span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          
          <div className="testimonials-nav">
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
          </div>
          
          <div className="testimonials-pagination"></div>
        </div>
      </Container>
    </section>
  );
};

export default Testimonials;
